import {Account, Actor, ClientEventType, Message, ServerEventType, SourceType} from './typings'

class Server {
    win: Window
    iframe: Window
    #events: {[key: string]: (message: Message) => any}
    constructor(iframe: HTMLIFrameElement) {
        this.iframe = iframe.contentWindow as Window
        this.win = window
        this.#events = {}
        this.addEventListener(async (message: Message) => {
            const fn = this.#events[message.type]
            if (fn) {
                const data = (await fn(message)) as Message
                this.postMessage(data)
            }
            // switch (data.type) {
            //     case EventType.GET_ACCOUNT:
            //         {
            //             fn(data.payload)
            //         }
            //         break
            //     default:
            //         throw new Error('type is not defined')
            // }
        })
    }
    on(type: ClientEventType, fn: (message: Message) => any) {
        this.#events[type] = fn
    }
    addEventListener(listener: (msg: Message) => any) {
        this.win.addEventListener('message', (e) => {
            const msg = e.data as Message
            if (msg.source === SourceType.AMAX_UP_CLIENT) {
                listener(msg)
            }
        })
    }
    postMessage(message: Message) {
        message.source = SourceType.AMAX_UP_SERVER
        this.iframe.postMessage(message, '*')
    }
    accountsChanged(accounts: Account[]) {
        this.postMessage({
            type: ServerEventType.ACCOUNTS_CHANGED,
            payload: accounts,
        } as Message)
    }
}

export default Server
